export const me = gql`
    query me {
        me {
            uuid
            email
            newEmailAwaitingConfirmation
            customer {
                lastName
                firstName
                phone
                street
                streetNumber
                postalCode
                city
                country
                company
                type
                hasBillingContact
                communicationPreferences
                payOnInvoiceStatus
                payOnInvoiceLimit
                payOnInvoicePeriod
                requestedPayOnInvoiceLimit
                requestedPayOnInvoicePeriod
                billingContact {
                    company
                    name
                    street
                    streetNumber
                    address2
                    address3
                    postalCode
                    city
                    country
                    email
                    phone
                    phoneCountry
                    vatNr
                    cocNr
                }
                invoices {
                    id
                    date
                    total
                    nr
                    status
                }
                orders {
                    id
                    number
                    total
                    dispatchType
                    discount
                    createdAt
                    requestedDeliveryAt
                    remarks
                    company
                    billingCompany
                    billingName
                    billingStreet
                    billingStreetNumber
                    billingPostalCode
                    billingCity
                    billingCountry
                    billingEmail
                    billingPhone
                    paymentMethod
                    paymentOption
                    paymentStatus
                    paymentCosts
                    deliveryCosts
                    packagingCosts
                    depositCosts
                    street
                    streetNumber
                    postalCode
                    city
                    country
                    firstName
                    lastName
                    phone
                    email
                    tip
                    status
                    orderProducts {
                        id
                        description
                        quantity
                        type
                        remarks
                        price
                        total
                        product {
                            id
                            title
                            description
                        }
                        orderProductExtras {
                            id
                            title
                            quantity
                            price
                            extra {
                                id
                                extraId
                                items {
                                    id
                                }
                            }
                        }
                    }
                }
                email
                phoneCountry
                birthdate
            }
        }
    }
`
